import React from 'react';
import { Section } from './ui/Section';
import { Key, Map, Zap } from 'lucide-react';
export function HowItWorksSection() {
  return <Section className="bg-tactical-surface/50 border-y border-tactical-surface2" data-id="element-130">
      <div className="text-center mb-16" data-id="element-131">
        <h2 className="text-4xl md:text-5xl mb-4" data-id="element-132">HOW IT WORKS</h2>
        <div className="w-24 h-1 bg-tactical-cyan mx-auto rounded-full" data-id="element-133"></div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-134">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-tactical-surface2" data-id="element-135">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-tactical-cyan/50 to-transparent" data-id="element-136"></div>
        </div>

        {[{
        step: '01',
        icon: Key,
        title: 'The Unlock',
        desc: "Read the playbook to identify your child's specific 'Reaction Gap'."
      }, {
        step: '02',
        icon: Map,
        title: 'The Blueprint',
        desc: "Implement the 10-minute 'Software Drills' in your backyard or hallway."
      }, {
        step: '03',
        icon: Zap,
        title: 'The Transformation',
        desc: "Watch as your child starts 'snapping their chin' and anticipating plays before they happen."
      }].map((item, i) => <div key={i} className="relative bg-tactical-dark border border-tactical-surface2 p-8 rounded-2xl text-center z-10 hover:border-tactical-cyan/30 transition-colors" data-id="element-137">
            <div className="absolute -top-4 -left-4 text-6xl font-oswald font-bold text-tactical-surface2/50 select-none pointer-events-none" data-id="element-138">
              {item.step}
            </div>
            <div className="w-16 h-16 mx-auto bg-tactical-surface rounded-full flex items-center justify-center mb-6 border border-tactical-cyan/20" data-id="element-139">
              <item.icon className="w-8 h-8 text-tactical-cyan" data-id="element-140" />
            </div>
            <h3 className="text-2xl mb-4" data-id="element-141">{item.title}</h3>
            <p className="text-slate-400 font-inter" data-id="element-142">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}